import EmptyState from './EmptyState'
import '../style/components/LoadingPlaceholder.css'
import '../style/components/RecapWeekList.css'

type Variant = 'all' | 'today' | 'week'

type RecapPlaceholderProps = {
  variant: Variant
}

function RecapPlaceholder({ variant }: RecapPlaceholderProps) {
  if (variant === 'today') {
    return (
      <div className="placeholder-shell placeholder-card">
        <div className="today-card">
          <div className="today-header">
            <div className="pill-row">
              <span className="pill pill-strong">Today</span>
              <span className="pill">2:30 PM</span>
              <span className="pill">On-site</span>
            </div>
            <div className="title-line" />
            <div className="subtitle-line" />
          </div>
          <div className="paragraph-block">
            <div className="line long" />
            <div className="line" />
            <div className="line short" />
          </div>
        </div>
      </div>
    )
  }

  if (variant === 'week') {
    return (
      <div className="placeholder-shell placeholder-plain stack">
        {[1, 2, 3].map((item) => (
          <EmptyState key={item} />
        ))}
      </div>
    )
  }

  return (
    <div className="placeholder-shell placeholder-plain">
      <div className="tiles-grid">
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={index} className="tile" />
        ))}
      </div>
    </div>
  )
}

export default RecapPlaceholder
